module.exports = __webpack_public_path__ + "static/media/chokha2.1a25e38f.jpeg";